import { http } from '@/api/client/httpClient';
import { downloadQuery } from '@/api/client/download';
import type { PagedResult } from '@/api/types/abp';
import type {
  ClientsAssetsDetailedInputDto,
  ClientsAssetsDetailedRowDto,
  ClientsAssetsSummaryDto,
  ClientsAssetsSummaryInputDto,
} from '@/api/types/clientsAssets';

// ABP route derivation (concrete AppService namespace ...ClientsAssets.ClientsAssetsAppService):
//   GetDetailedReportForDataTable(ClientsAssetsDetailedInputDto) -> GET  /detailed-report-for-data-table (query)
//   GetSummary(ClientsAssetsSummaryInputDto)                     -> GET  /summary (query)
//   GetExtractExcel(DateTime,bool)                               -> GET  /extract-excel (query, blob)
// `Get` is stripped from each action name (verb stays GET); complex DTOs bind from
// the query string on Get-prefixed methods.
const CA = '/api/app/clients-assets';

export const clientsAssetsApi = {
  getDetailedReportForDataTable: (input: ClientsAssetsDetailedInputDto) =>
    http
      .get<PagedResult<ClientsAssetsDetailedRowDto>>(`${CA}/detailed-report-for-data-table`, { params: input })
      .then((r) => r.data),

  getSummary: (input: ClientsAssetsSummaryInputDto) =>
    http.get<ClientsAssetsSummaryDto>(`${CA}/summary`, { params: input }).then((r) => r.data),

  extractExcel: (input: ClientsAssetsSummaryInputDto, fallback: string) =>
    downloadQuery(`${CA}/extract-excel`, { referenceDate: input.referenceDate, isLive: input.isLive }, fallback),
};
